import { render, staticRenderFns } from "./assetDetailsUi.vue?vue&type=template&id=65ffff59&scoped=true"
import script from "./assetDetailsUi.vue?vue&type=script&lang=js"
export * from "./assetDetailsUi.vue?vue&type=script&lang=js"
import style0 from "./assetDetailsUi.vue?vue&type=style&index=0&id=65ffff59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffff59",
  null
  
)

export default component.exports